import React, { useState, useEffect, useRef } from "react";
import "./ExecutiveSnapshot.css";
import InsightBlock from "../../InsightBlock";
import * as FeatherIcon from "react-feather";
import CompetitorBanner from "./CompetitorBanner";
import StrategicCustomerIntelligence from "./StrategicCustomerIntelligence";
import AiTechStackCapabilitySummary from "./AiTechStackCapabilitySummary";
import TopRightActionLinks from "../../TopRightActionLinks";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import AIChat from "../../../Chat/AiChat";
import { useParams } from "react-router-dom";
import RatingProgressBar from "./RatingProgressBar";
import CompetitorScorecard from "./CompetitorScorecard";
import CompetitiveIntelligenceDashboard from "./CompetitiveIntelligenceDashboard";
import ExecutiveSummaryNextSteps from "./ExecutiveSummaryNextSteps";
import CompanyBaselineProfile from "./CompanyBaselineProfile";
import ScoreCard from "./ScoreCard";
import GenericTableSkeleton from "../../../skeletons/tableSkeleton/genericTableSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { submitCompetitorProfileV3Request } from "../../../../../store/features/actions/competitorProfileV3Actions";
import {
  getAllSubdimensionMatches,
  getAllPageInsights,
  formatBoldText,
  getCompProfilePageInsights,
  hasData,
} from "../../../../../services/commonService";
import { Tooltip } from "react-tooltip";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import { useCompetitorContext } from "../../../../../context/CompetitorContext";

function ExecutiveSnapshot({
  handleTabChange,
  activeSubKey,
  setActiveSubKey,
  dataReportCheck,
  scrollTarget,
  scrollContainerRef,
}) {
  const [staticDataLoading, setStaticDataLoading] = useState(true);

  setTimeout(() => {
    setStaticDataLoading(false);
  }, 1000);

  const execSnapCompanyOverviewRef = useRef(null);
  const insightSummaryRef = useRef(null);
  const overallCompetitiveThreatAssessmentRef = useRef(null);
  const companyScorecardRef = useRef(null);
  const companyBaselineProfileRef = useRef(null);
  const competitiveIntelligenceDashboardRef = useRef(null);
  const executiveSummaryNextStepsRef = useRef(null);
  const programmaticScrollRef = useRef(false);

  const [showConversationModal, setShowConversationModal] = useState(false);
  const [companyOverview, setCompanyOverview] = useState([]);
  const [pagePositives, setPagePositives] = useState([]);
  const [pageNegatives, setPageNegatives] = useState([]);
  const [pageSoWhat, setPageSoWhat] = useState([]);
  const { clientName, competitorName } = useParams();
  const [threatScore, setThreatScore] = useState("");
  const [overallThreatAssesment, setOverallThreatAssesment] = useState([]);
  const [scorecardData, setScorecardData] = useState([]);
  const [baselineData, setBaselineData] = useState([]);
  const [nextStepsData, setNextStepsData] = useState([]);
  const [execSnapDataCheck, setExecSnapDataCheck] = useState({
    hasExecCompanyOverviewTabData: true,
    hasInsightSummaryTabData: true,
    hasOverallCompetitiveThreatAssessmentTabData: true,
    hasCompanyScorecardTabData: true,
    hasCompanyBaselineProfileTabData: true,
    hasCompetitiveIntelligenceDashboardTabData: true,
    hasExecutiveSummaryNextStepsTabData: true,
  });

  const { competitorInfo } = useCompetitorContext();
  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // {
    //   type: "conversation",
    //   title: "Conversation",
    //   onClick: () => {
    //     setShowConversationModal((prev) => !prev);
    //   },
    // },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    // { type: "download", title: "Download", onClick: () => {} },
  ];

  const sectionMap = {
    execCompanyOverviewTab: execSnapCompanyOverviewRef,
    insightSummaryTab: insightSummaryRef,
    overallCompetitiveThreatAssessmentTab:
      overallCompetitiveThreatAssessmentRef,
    companyScorecardTab: companyScorecardRef,
    companyBaselineProfileTab: companyBaselineProfileRef,
    competitiveIntelligenceDashboardTab: competitiveIntelligenceDashboardRef,
    executiveSummaryNextStepsTab: executiveSummaryNextStepsRef,
  };

  const scrollToSection = (key) => {
    const ref = sectionMap[key];
    if (!ref?.current) return;

    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  // useEffect(() => {
  //   if (!activeSubKey) return;
  //   const sectionMap = {
  //     insightSummaryTab: insightSummaryRef,
  //     overallCompetitiveThreatAssessmentTab:
  //       overallCompetitiveThreatAssessmentRef,
  //     companyScorecardTab: companyScorecardRef,
  //     companyBaselineProfileTab: companyBaselineProfileRef,
  //     competitiveIntelligenceDashboardTab: competitiveIntelligenceDashboardRef,
  //     executiveSummaryNextStepsTab: executiveSummaryNextStepsRef,
  //   };

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     const yOffset = -100; // adjust based on your sticky header height
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });
  //   }
  // }, [activeSubKey]);

  const dispatch = useDispatch();

  const { loading, data, error } = useSelector(
    (state) => state.competitorProfileV3Reducer
  );

  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;
    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // useEffect(() => {
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       const scrollPosition = window.scrollY + 120; // offset to trigger slightly earlier
  //       let currentKey = null;

  //       Object.entries(sectionMap).forEach(([key, ref]) => {
  //         if (!ref.current) return;
  //         const sectionTop = ref.current.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           currentKey = key;
  //         }
  //       });

  //       // update parent only if different
  //       if (currentKey && currentKey !== activeSubKey) {
  //         setActiveSubKey(currentKey);
  //       }
  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   // trigger once on mount to set correct nav if already scrolled
  //   handleScroll();

  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [activeSubKey, setActiveSubKey]);

  useEffect(() => {
    let scrollTimeout = null;
    let ticking = false;

    const handleScroll = () => {
      if (programmaticScrollRef.current) return; // ignore programmatic scrolls
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        // Clear previous timeout (debounce)
        if (scrollTimeout) clearTimeout(scrollTimeout);

        // Wait until user stops scrolling for 200ms
        scrollTimeout = setTimeout(() => {
          const scrollPosition = window.scrollY + 120; // offset for header, etc.
          let currentKey = null;

          Object.entries(sectionMap).forEach(([key, ref]) => {
            if (!ref.current) return;
            const sectionTop = ref.current.offsetTop;
            const sectionHeight = ref.current.offsetHeight;

            // Check if scroll is within this section
            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              currentKey = key;
            }
          });

          // update nav only if different
          if (currentKey && currentKey !== activeSubKey) {
            setActiveSubKey(currentKey);
          }
        }, 200); // change nav only after 200ms of no scrolling

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // run once on mount
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    setPagePositives([
      "**Operation Excellence**: Tailored Chemicals demonstrates operational excellence through well-structured, quality-focused manufacturing and supply processes that ensure consistent, efficient, and compliant delivery of specialty adhesives.",
      "**Customer Loyalty**: Delivering superior quality on time strengthens customer trust and loyalty",
      "**Vertical Integration: Own fleet + resin production** creates supply security",
      "**Family Agility: Third-generation leadership** enables faster strategic pivots",
    ]);
    setPageNegatives([
      "**Geographic Concentration**: Heavy reliance on NC plants, with limited out-of-state diversification.",
      "**Limited Innovation: Zero patents** indicates weak IP protection",
      // "**Distributor Dependence**: Relies heavily on distributors for customer access and market reach, which can pressure margins and limit direct customer relationships.",
      "**Capital Constraints: Private ownership** limits expansion funding",
    ]);
    setPageSoWhat([
      "**Capitalize**: H.B. Fuller’s global scale and R&D strength contrast TCP’s concentrated NC footprint, limited IP, and distributor reliance — positioning Fuller to capture margin and innovation opportunities.",
      // "**Accelerate**: H.B. Fuller can invest in service enhancements to neutralize TCP’s local agility, while TCP’s private ownership may limit funding and increase acquisition risk.",
    ]);
  }, []);

  const formData = {
    // dimension: "Executive_Snapshot",
    dimension: "Executive Snapshot",
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
  };
  useEffect(() => {
    dispatch(submitCompetitorProfileV3Request(formData));
  }, []);

  useEffect(() => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
    const container = scrollContainerRef?.current || window;

    container.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const filterByScoreCard = (data = []) => {
    // Default to an empty array if data is undefined
    if (!Array.isArray(data)) {
      console.error("Expected an array but received:", typeof data);
      return [];
    }
    return data.filter((item) =>
      item.response?.subdimension_name?.endsWith("_ScoreCard")
    );
  };

  useEffect(() => {
    const tempCompOverview = getAllSubdimensionMatches(
      data,
      "Company_Overview"
    );
    setCompanyOverview(tempCompOverview);

    const tempOverallThreatAssesment = getAllSubdimensionMatches(
      data,
      "Overall_Competitive_Threat_Assessment"
    );
    setOverallThreatAssesment(tempOverallThreatAssesment[0]?.response);

    // console.log("THREAT: " + JSON.stringify(overallThreatAssesment));

    const { positive, negative, sowhat } = getCompProfilePageInsights(data);
    setPagePositives(formatBoldText(positive) || []);
    setPageNegatives(formatBoldText(negative) || []);
    setPageSoWhat(formatBoldText(sowhat) || []);

    const tempScorecardData = filterByScoreCard(data?.results);
    setScorecardData(tempScorecardData);
    // console.log("SCORECARDData: " + JSON.stringify(tempScorecardData));

    const tempBaselineData = data?.baseline || [];
    setBaselineData(tempBaselineData);

    const tempNextStepsData = getAllSubdimensionMatches(
      data,
      "Executive_Summary_Next_Steps"
    );
    setNextStepsData(tempNextStepsData);

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE

    const newChecks = {
      hasInsightSummaryTabData:
        hasData(positive) || hasData(negative) || hasData(sowhat),
      hasExecCompanyOverviewTabData: hasData(tempCompOverview),
      hasOverallCompetitiveThreatAssessmentTabData: hasData(
        tempOverallThreatAssesment
      ),
      hasCompanyScorecardTabData: hasData(tempScorecardData),
      hasCompanyBaselineProfileTabData: hasData(tempBaselineData),
      hasCompetitiveIntelligenceDashboardTabData: hasData(data?.dashboard_data), // Assuming this exists in your data
      hasExecutiveSummaryNextStepsTabData: hasData(tempNextStepsData),
    };

    setExecSnapDataCheck(newChecks);

    dataReportCheck("insightSummaryTab", newChecks.hasInsightSummaryTabData);
    dataReportCheck(
      "execCompanyOverviewTab",
      newChecks.hasExecCompanyOverviewTabData
    );
    dataReportCheck(
      "overallCompetitiveThreatAssessmentTab",
      newChecks.hasOverallCompetitiveThreatAssessmentTabData
    );
    dataReportCheck(
      "companyScorecardTab",
      newChecks.hasCompanyScorecardTabData
    );
    dataReportCheck(
      "companyBaselineProfileTab",
      newChecks.hasCompanyBaselineProfileTabData
    );
    dataReportCheck(
      "executiveSummaryNextStepsTab",
      newChecks.hasExecutiveSummaryNextStepsTabData
    );

    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasInsightSummaryTabData: !!(
    //     positive?.length ||
    //     negative?.length ||
    //     sowhat?.length
    //   ),
    // }));

    // dataReportCheck(
    //   "insightSummaryTab",
    //   execSnapDataCheck.hasInsightSummaryTabData
    // );

    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasExecCompanyOverviewTabData: !!companyOverview,
    // }));

    // dataReportCheck(
    //   "execCompanyOverviewTab",
    //   execSnapDataCheck.hasExecCompanyOverviewTabData
    // );

    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasOverallCompetitiveThreatAssessmentTabData:
    //     tempOverallThreatAssesment?.length
    //       ? !!tempOverallThreatAssesment
    //       : false,
    // }));

    // dataReportCheck(
    //   "overallCompetitiveThreatAssessmentTab",
    //   execSnapDataCheck.hasOverallCompetitiveThreatAssessmentTabData
    // );

    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasCompanyScorecardTabData: scorecardData?.length
    //     ? !!scorecardData
    //     : false,
    // }));

    // dataReportCheck(
    //   "companyScorecardTab",
    //   execSnapDataCheck.hasCompanyScorecardTabData
    // );
    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasCompanyBaselineProfileTabData: baselineData ? !!baselineData : false,
    // }));

    // dataReportCheck(
    //   "companyBaselineProfileTab",
    //   execSnapDataCheck.hasCompanyBaselineProfileTabData
    // );

    // // setExecSnapDataCheck((prevState) => ({
    // //   ...prevState,
    // //   hasCompetitiveIntelligenceDashboardTabData:
    // //     !!competitiveIntelligenceDashboard,
    // // }));

    // // dataReportCheck(
    // //   "competitiveIntelligenceDashboardTab",
    // //   execSnapDataCheck.hasCompetitiveIntelligenceDashboardTabData
    // // );

    // setExecSnapDataCheck((prevState) => ({
    //   ...prevState,
    //   hasExecutiveSummaryNextStepsTabData: !!baselineData,
    // }));

    // dataReportCheck(
    //   "executiveSummaryNextStepsTab",
    //   execSnapDataCheck.hasExecutiveSummaryNextStepsTabData
    // );
    // CODE TO MAKE TABS HIDDEN IF DATA NOT AVAILABLE
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }, [data]);

  // Show only for specific competitor from URL
  const shouldShowStratTables =
    (competitorName || "").trim().toLowerCase() === "bostik";

  // ---------- Editable static data (change anytime) ----------
  const FOCUS_ROW = {
    productFocus:
      "Smart/advanced adhesives & sealants (“smart adhesives”) for industry & consumers.",
    geographicFocus:
      "Global footprint: ~50 countries; >6,000 employees; locations & plants on 5 continents.",
    endUseIndustryFocus:
      "Construction (wall & floor; sealing & bonding), mobility/transportation, packaging & labeling, disposable hygiene, assembly/industrial manufacturing, DIY.",
    customerSegment:
      "Industrial OEMs/manufacturers, construction professionals/contractors, DIY/retail users.",
  };

  const LEVERS_ROW = {
    salesModel:
      "Hybrid model: direct to key accounts + broad distributor/retailer network (distributor locators; named distribution partners).",
    valueProposition: `"Smart adhesives” performance + sustainability narrative; solutions spanning industries.`,
    techInnovationLevers:
      "Central R&D + Smart Technology Center (Venette, FR); materials-science-led innovation; Born2Bond™ engineering adhesive platform.",
    costServiceAdvantage:
      "Technical training & support (Bostik Academy; technical helpdesks) + global service reach.",
    partnershipOption:
      "Distributors & channel partners (e.g., DGE, Biesterfeld); ecosystem partnerships; capability strengthened via Ashland Performance Adhesives acquisition (Arkema).",
  };

  // ---------- Neutral look & feel (like the Scorecard) ----------
  const tableShell = {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    background: "#ffffff",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
    overflow: "hidden",
    margin: "10px 0 18px",
  };
  const tableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    minWidth: 980,
  };
  const thBase = {
    background: "#f8fafc", // light slate like your scorecard
    color: "#0f172a",
    fontWeight: 700,
    fontSize: 13,
    padding: "10px 12px",
    borderBottom: "1px solid #e5e7eb",
    textAlign: "left",
    verticalAlign: "top",
  };
  const tdBase = {
    background: "#ffffff",
    color: "#0b1220",
    fontWeight: 400,
    fontSize: 13,
    padding: "10px 12px",
    borderTop: "1px solid #f1f5f9",
  };
  const colDivider = { borderRight: "1px solid #e5e7eb" };
  const noDivider = { borderRight: "none" };
  const trColorBg = { backgroundColor: "#fff" };

  // ---------- Single-row tables ----------
  function StrategicFocusTable({ row }) {
    return (
      <div style={tableShell}>
        <table style={tableStyle}>
          <thead>
            <tr style={trColorBg}>
              <th style={{ ...thBase, ...colDivider }}>Product Focus</th>
              <th style={{ ...thBase, ...colDivider }}>Geographic Focus</th>
              <th style={{ ...thBase, ...colDivider }}>
                End Use Industry Focus
              </th>
              <th style={{ ...thBase, ...colDivider }}>Customer Segment</th>
            </tr>
          </thead>
          <tbody style={{ background: "#ffffff" }}>
            <tr>
              <td style={{ ...tdBase, ...colDivider }}>{row.productFocus}</td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.geographicFocus}
              </td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.endUseIndustryFocus}
              </td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.customerSegment}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  function StrategicLeversTable({ row }) {
    return (
      <div style={tableShell}>
        <table style={tableStyle}>
          <thead>
            <tr style={trColorBg}>
              <th style={{ ...thBase, ...colDivider }}>Sales Model</th>
              <th style={{ ...thBase, ...colDivider }}>Value Proposition</th>
              <th style={{ ...thBase, ...colDivider }}>
                Tech &amp; Innovation Levers
              </th>
              <th style={{ ...thBase, ...colDivider }}>
                Cost &amp; Service Advantage
              </th>
              <th style={{ ...thBase, ...colDivider }}>Partnership Option</th>
            </tr>
          </thead>
          <tbody style={{ background: "#ffffff" }}>
            <tr>
              <td style={{ ...tdBase, ...colDivider }}>{row.salesModel}</td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.valueProposition}
              </td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.techInnovationLevers}
              </td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.costServiceAdvantage}
              </td>
              <td style={{ ...tdBase, ...colDivider }}>
                {row.partnershipOption}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // HANDLE SCROLL FROM SEARCH (from parent via scrollTarget)
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!scrollTarget) return;

  //   // Don't scroll if data is still loading
  //   if (staticDataLoading) {
  //     console.log("⏳ Waiting for data to load...");
  //     return;
  //   }

  //   const targetKey = scrollTarget.key;
  //   const sectionRef = sectionMap[targetKey];

  //   const scrollToSection = () => {
  //     if (!sectionRef?.current) {
  //       requestAnimationFrame(scrollToSection);
  //       return;
  //     }

  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const element = sectionRef.current;
  //     const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

  //     window.scrollTo({ top: y, behavior: "smooth" });

  //     setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);
  //   };

  //   // Give extra time for skeleton to disappear and content to render
  //   const timer = setTimeout(() => {
  //     requestAnimationFrame(scrollToSection);
  //   }, 1400); // Increase this if staticDataLoading timeout is 1000ms

  //   return () => clearTimeout(timer);
  // }, [scrollTarget, staticDataLoading]); // ADD staticDataLoading to deps
  useEffect(() => {
    if (!scrollTarget || staticDataLoading) return;

    const timer = setTimeout(() => {
      scrollToSection(scrollTarget.key);
    }, 900);

    return () => clearTimeout(timer);
  }, [scrollTarget, staticDataLoading]);
  // +++++++++++++++++++++++++++++++++++++++++++++++++

  return (
    <div className="excutive_snapshot_wrapper">
      {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <div className="excutive_headblock">
          <div className="excutive_subheadblock">
            <h5 className="excutive_head">Executive Snapshot</h5>
            <p className="excutive_para">
              Strategic clarity, competitive signals, and threats — built for
              fast, executive action.
            </p>
          </div>
          <div className="excutive_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
      )}

      {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        execSnapDataCheck.hasExecCompanyOverviewTabData && (
          <>
            <div
              ref={execSnapCompanyOverviewRef}
              style={{
                display: "flex",
              }}
            >
              <CompetitorBanner
                companyOverview={companyOverview}
                handleTabChange={handleTabChange}
                competitorInfo={competitorInfo}
              />
            </div>
          </>
        )
      )}

      {/* <div className="strat_excutive_wrapper">
        <div className="strat_excutive_block">
          <div className="strat_excutive_block_left">
            <h6 className="strat_excutive_block_head">
              Strategic Executive Overview
            </h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="strat_excutive_subblock">
              <p className="strat_excutive_para">
                {competitorName} is evolving from a product distributor into a
                full-stack supply chain and clinical solutions provider. Their
                vertical integration strategy — from manufacturing through
                logistics to point-of-care delivery — is allowing them to
                undercut traditional GPO-negotiated channels, particularly
                across non-acute and ambulatory networks.
              </p>
              <p className="strat_excutive_para">
                Their aggressive expansion in surgical kits, physician office
                packs, and just-in-time inventory capabilities poses a strategic
                threat to {clientName}’s hospital-focused distribution model.
                {competitorName}’s ability to customize at scale while managing
                its own fleet is accelerating customer stickiness and margin
                erosion for competitors.
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        execSnapDataCheck.hasInsightSummaryTabData && (
          <div style={{ marginBottom: "25px" }} ref={insightSummaryRef}>
            <InsightBlock
              title={""}
              overview={""}
              actions={[]}
              pagePositives={pagePositives}
              pageNegatives={pageNegatives}
              pageSoWhat={pageSoWhat}
            />
          </div>
        )
      )}

      {/* ++++++++++++++++++++++++++++++ */}
      {/* <!-- Overall Score Summary --> */}
      {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <>
          {execSnapDataCheck.hasOverallCompetitiveThreatAssessmentTabData && (
            <div
              style={{ marginBottom: "25px" }}
              className="overall_score_wrapper"
              ref={overallCompetitiveThreatAssessmentRef}
            >
              <h3 className="overall_head">
                Overall Competitive Threat Assessment
              </h3>

              <div className="block_overall">
                <div className="value_block" style={{ textAlign: "center" }}>
                  <div
                    className="value_subblock"
                    style={{
                      color: "#f59e0b",
                    }}
                  >
                    {threatScore ? threatScore + "/10" : "-"}
                  </div>
                  <div className="value_block_score">Overall Score</div>
                </div>

                <div className="value_block" style={{ textAlign: "center" }}>
                  <div
                    className="value_subblock"
                    style={{
                      color: "#ef4444",
                    }}
                  >
                    {overallThreatAssesment?.metrics?.threat_level?.value ?? ""}
                    <FeatherIcon.Info
                      className="ml-2 fa"
                      style={{
                        width: "12px",
                        height: "12px",
                        cursor: "pointer",
                      }}
                      data-tooltip-id="threat-id"
                    />
                    <Tooltip
                      id="threat-id"
                      className="custom-tooltip-executive"
                      content={
                        formatBoldText(
                          <ParsedTextWithLinks
                            text={
                              overallThreatAssesment?.metrics?.threat_level
                                ?.justification
                            }
                          />
                        ) ?? ""
                      }
                      clickable
                      place="top"
                    />
                  </div>
                  <div className="value_block_score">Threat Level</div>
                </div>

                <div className="value_block" style={{ textAlign: "center" }}>
                  <div
                    className="value_subblock"
                    style={{
                      color: "#10b981",
                    }}
                  >
                    {overallThreatAssesment?.metrics?.efficiency?.value ?? ""}
                    <FeatherIcon.Info
                      className="ml-2 fa"
                      style={{
                        width: "12px",
                        height: "12px",
                        cursor: "pointer",
                      }}
                      data-tooltip-id="efficiency-id"
                    />
                    <Tooltip
                      id="efficiency-id"
                      className="custom-tooltip-executive"
                      content={
                        formatBoldText(
                          <ParsedTextWithLinks
                            text={
                              overallThreatAssesment?.metrics?.efficiency
                                ?.justification
                            }
                          />
                        ) ?? ""
                      }
                      clickable
                      place="top"
                    />
                  </div>
                  <div className="value_block_score">Efficiency</div>
                </div>

                <div className="value_block" style={{ textAlign: "center" }}>
                  <div
                    className="value_subblock"
                    style={{
                      color: "#ef4444",
                    }}
                  >
                    {overallThreatAssesment?.metrics?.acquisition_risk?.value ??
                      ""}
                    <FeatherIcon.Info
                      className="ml-2 fa"
                      style={{
                        width: "12px",
                        height: "12px",
                        cursor: "pointer",
                      }}
                      data-tooltip-id="acquisition-risk-id"
                    />
                    <Tooltip
                      id="acquisition-risk-id"
                      className="custom-tooltip-executive"
                      content={
                        formatBoldText(
                          <ParsedTextWithLinks
                            text={
                              overallThreatAssesment?.metrics?.acquisition_risk
                                ?.justification
                            }
                          />
                        ) ?? ""
                      }
                      clickable
                      place="top"
                    />
                  </div>
                  {/* <div className="value_block_score">Acquisition Risk</div> */}
                  <div className="value_block_score">Ability to Acquire</div>
                </div>
              </div>
            </div>
          )}

          {execSnapDataCheck.hasCompanyScorecardTabData && (
            <div style={{ marginBottom: "20px" }} ref={companyScorecardRef}>
              <ScoreCard
                scorecardData={scorecardData}
                setThreatScore={setThreatScore}
              />
            </div>
          )}
        </>
      )}

      {/* Strategic tables (below scorecard, above baseline) */}

      {shouldShowStratTables && (
        <>
          {<h4 className="company_name">Strategic Focus</h4>}
          <StrategicFocusTable row={FOCUS_ROW} />
          {<h4 className="company_name">Strategic Levers</h4>}
          <StrategicLeversTable row={LEVERS_ROW} />
        </>
      )}

      {/* COMPANY BSELINE SECTION */}
      {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        execSnapDataCheck.hasCompanyBaselineProfileTabData && (
          <div style={{ marginBottom: "25px" }} ref={companyBaselineProfileRef}>
            <CompanyBaselineProfile baselineData={baselineData} />
          </div>
        )
      )}
      {/* COMPANY BSELINE SECTION */}

      {/* ++++++++++++++++++++++++++++++ */}

      {/* <div className="start_customer_wrapper mb-2">
        <CompetitorScorecard competitorScorecard={[]} />
      </div> */}

      {/* <div ref={competitiveIntelligenceDashboardRef}>
        <CompetitiveIntelligenceDashboard />
      </div> */}

      {/* {staticDataLoading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : (
        <div ref={executiveSummaryNextStepsRef}>
          <ExecutiveSummaryNextSteps nextStepsData={nextStepsData} />
        </div>
      )} */}

      {/* <div className="quickstats_wrapper mb-2">
        <div className="quickstats_block">
          <div className="quickstats_block_left">
            <h6 className="quickstats_block_head">Quick Stats</h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">Revenue (FY2024)</h5>
              <p className="poistive_green">
                Estimated USD 90-110Mn (Not disclosed)
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">EBITDA (est.)</h5>
              <p className="neutral_black">Not disclosed</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">R&D Investment (est.)</h5>
              <p className="poistive_green">
                {" "}
                {"<"} $1M (est. {"<"} 1%)
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">Operating Margin</h5>
              <p className="neutral_black">Not disclosed</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">Private Label Share</h5>
              <p className="neutral_black">Not disclosed</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="quick_stats_subblock">
              <h5 className="quick_head">Employees</h5>
              <p className="neutral_black">205</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="stratsnapshot_wrapper mb-2">
        <div className="stratsnapshot_block">
          <div className="stratsnapshot_block_left">
            <h6 className="stratsnapshot_block_head">
              Strategic Threat Snapshot
            </h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="stratsnapshot_subblock">
              <h5 className="stratsnapshot_head">
                Market Share (U.S. Adhesives)
              </h5>
              <h6 className="stratsnapshot_subhead">Estimated {"<"} 1% (↔)</h6>
              <p className="stratsnapshot_para">
                Regional player in $10B+ U.S. adhesives market with $101.9M
                revenue
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stratsnapshot_subblock">
              <h5 className="stratsnapshot_head">Innovation Velocity</h5>
              <h6 className="stratsnapshot_subhead">
                Low – 0 patents, minimal R&D
              </h6>
              <p className="stratsnapshot_para">
                No patent portfolio found, no certified products, traditional
                manufacturing focus
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stratsnapshot_subblock">
              <h5 className="stratsnapshot_head">Threat Index</h5>
              <h6 className="stratsnapshot_subhead">3.5 / 10</h6>
              <p className="stratsnapshot_para">
                Limited scale, regional focus, and lack of innovation reduce
                competitive threat
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stratsnapshot_subblock">
              <h5 className="stratsnapshot_head">Expansion Aggression</h5>
              <h6 className="stratsnapshot_subhead">
                1 acquisition in 3 years (2021)
              </h6>
              <p className="stratsnapshot_para">
                Industrial Adhesives of Indiana acquisition for Midwest
                expansion
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stratsnapshot_subblock">
              <h5 className="stratsnapshot_head">Account Overlap</h5>
              <h6 className="stratsnapshot_subhead">
                ~15-20% in Southeast furniture
              </h6>
              <p className="stratsnapshot_para">
                Strong in Carolina furniture market, minimal presence in H.B.
                Fuller's key segments
              </p>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="compmove_wrapper mb-2">
        <div className="compmove_block">
          <div className="compmove_block_left">
            <h6 className="compmove_block_head">Competitive Movement Feed</h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="compmove_subblock">
              <h5 className="compmove_head">
                Indiana Expansion (Midwest Push)
              </h5>
              <p className="compmove_para">
                Acquired Industrial Adhesives of Indiana to expand Midwest
                manufacturing and distribution presence.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Manufacturing Expansion</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Industry News</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2021</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link">
                    <img
                      src="/img/comp_link.png"
                      className="icon_link"
                      alt="icon"
                    />
                    Verified acquisition
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="compmove_subblock">
              <h5 className="compmove_head">Hot Melt Facility Investment</h5>
              <p className="compmove_para">
                Opened 100,000 sq ft dedicated hot melt adhesive manufacturing
                facility in North Carolina.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Manufacturing Capacity</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Company Announcement</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2012</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link">
                    <img
                      src="/img/comp_link.png"
                      className="icon_link"
                      alt="icon"
                    />
                    $30M+ investment
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="compmove_subblock">
              <h5 className="compmove_head">
                Tyler, Texas Facility (Planned/Stalled)
              </h5>
              <p className="compmove_para">
                Announced plans for Texas facility to achieve 95% of U.S.
                customers within 2-day shipping radius.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Geographic Expansion</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Company Website</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2019-2020</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link">
                    <img
                      src="/img/comp_link.png"
                      className="icon_link"
                      alt="icon"
                    />
                    Status unclear
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="compmove_subblock">
              <h5 className="compmove_head">Metallocene Technology Launch</h5>
              <p className="compmove_para">
                Introduced metallocene hot melt adhesives offering 30-40% usage
                reduction for packaging customers.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Product Innovation</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Case Studies</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2015</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link">
                    <img
                      src="/img/comp_link.png"
                      className="icon_link"
                      alt="icon"
                    />
                    Premium product line
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="start_customer_wrapper mb-2">
        <StrategicCustomerIntelligence />
      </div> */}

      {/* <div className="global_fooprint_wrapper mb-2">
        <div className="global_subblock">
          <div className="global_block_sub">
            <h5 className="global_head_text">
              Global Footprint & GTM Intensity
            </h5>
            <p className="global_para_text">
              {competitorName}’s operations span over 125 countries, with a
              dominant presence in North America and strategic expansion across
              LATAM and EMEA. While still primarily U.S.-centric, its
              international GTM intensity has increased via localized
              manufacturing partnerships and third-party logistics alliances.
            </p>
          </div>
          <div className="global_btn_block">
            <TopRightActionLinks actions={actions} />
          </div>
        </div>
      </div> */}

      {/* <div className="aitech_capability_wrapper">
        <AiTechStackCapabilitySummary />
      </div> */}

      {/* <div className="risk_center_wrapper">
        <div className="risk_center_block">
          <div className="risk_center_block_left">
            <h6 className="risk_center_block_head">Risk Center</h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="risk_center_subblock">
              <div className="alert_block">
                <div className="alert_icon_block">
                  <img
                    src="/img/alert_sign.png"
                    className="icon_link"
                    alt="icon"
                  />
                </div>
                <div className="alert_text_block">
                  <h5 className="risk_center_head">
                    Market Share (U.S. Med-Surg)
                  </h5>
                  <p className="risk_center_para">
                    Fastest growth in ambulatory surgical centers and long-term
                    care channels.`
                  </p>
                  <div className="comp_bottom_block">
                    <div className="comp_bottom_left">
                      <p className="comp_text_para">Digital Technology</p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>Digital Twin</i>
                      </p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>2025-07-18</i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="risk_center_subblock">
              <div className="alert_block">
                <div className="alert_icon_block">
                  <img
                    src="/img/alert_sign.png"
                    className="icon_link"
                    alt="icon"
                  />
                </div>
                <div className="alert_text_block">
                  <h5 className="risk_center_head">
                    Market Share (U.S. Med-Surg)
                  </h5>
                  <p className="risk_center_para">
                    Fastest growth in ambulatory surgical centers and long-term
                    care channels.`
                  </p>
                  <div className="comp_bottom_block">
                    <div className="comp_bottom_left">
                      <p className="comp_text_para">Digital Technology</p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>Digital Twin</i>
                      </p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>2025-07-18</i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="risk_center_subblock">
              <div className="alert_block">
                <div className="alert_icon_block">
                  <img
                    src="/img/alert_sign.png"
                    className="icon_link"
                    alt="icon"
                  />
                </div>
                <div className="alert_text_block">
                  <h5 className="risk_center_head">
                    Market Share (U.S. Med-Surg)
                  </h5>
                  <p className="risk_center_para">
                    Fastest growth in ambulatory surgical centers and long-term
                    care channels.`
                  </p>
                  <div className="comp_bottom_block">
                    <div className="comp_bottom_left">
                      <p className="comp_text_para">Digital Technology</p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>Digital Twin</i>
                      </p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>2025-07-18</i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="risk_center_subblock">
              <div className="alert_block">
                <div className="alert_icon_block">
                  <img
                    src="/img/alert_sign.png"
                    className="icon_link"
                    alt="icon"
                  />
                </div>
                <div className="alert_text_block">
                  <h5 className="risk_center_head">
                    Market Share (U.S. Med-Surg)
                  </h5>
                  <p className="risk_center_para">
                    Fastest growth in ambulatory surgical centers and long-term
                    care channels.`
                  </p>
                  <div className="comp_bottom_block">
                    <div className="comp_bottom_left">
                      <p className="comp_text_para">Digital Technology</p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>Digital Twin</i>
                      </p>
                      <p className="comp_dot">•</p>
                      <p className="comp_text_para">
                        <i>2025-07-18</i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="leadership_signal_wrapper">
        <div className="leadership_signal_block">
          <div className="leadership_signal_block_left">
            <h6 className="leadership_signal_block_head">Leadership Signals</h6>
          </div>
          <TopRightActionLinks actions={actions} section_type="company" />
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="leadership_signal_subblock">
              <h5 className="leadership_signal_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="leadership_signal_para">
                Brings deep experience in fulfillment automation and last-mile
                orchestration. Expected to accelerate tech-driven logistics
                disruption.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Digital Technology</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Digital Twin</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2025-07-18</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_high">
                    High
                  </a>
                </div>
              </div>
            </div>

            <div className="leadership_signal_subblock">
              <h5 className="leadership_signal_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="leadership_signal_para">
                Brings deep experience in fulfillment automation and last-mile
                orchestration. Expected to accelerate tech-driven logistics
                disruption.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Digital Technology</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Digital Twin</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2025-07-18</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_med">
                    Medium
                  </a>
                </div>
              </div>
            </div>

            <div className="leadership_signal_subblock">
              <h5 className="leadership_signal_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="leadership_signal_para">
                Brings deep experience in fulfillment automation and last-mile
                orchestration. Expected to accelerate tech-driven logistics
                disruption.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Digital Technology</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Digital Twin</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2025-07-18</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_high">
                    High
                  </a>
                </div>
              </div>
            </div>

            <div className="leadership_signal_subblock">
              <h5 className="leadership_signal_head">
                New Chief Digital Officer (ex-Amazon):
              </h5>
              <p className="leadership_signal_para">
                Brings deep experience in fulfillment automation and last-mile
                orchestration. Expected to accelerate tech-driven logistics
                disruption.
              </p>
              <div className="comp_bottom_block">
                <div className="comp_bottom_left">
                  <p className="comp_text_para">Digital Technology</p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>Digital Twin</i>
                  </p>
                  <p className="comp_dot">•</p>
                  <p className="comp_text_para">
                    <i>2025-07-18</i>
                  </p>
                </div>
                <div className="comp_bottom_right">
                  <a href="#" className="comp_link_med">
                    Medium
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This: {competitorName} - Market Insights
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={"Executive Snapshot"} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}

export default ExecutiveSnapshot;
